import { Action } from '@ngrx/store';
import { AllotmentPreferences } from '../../types/allotment-preferences.types';

export enum AllotmentPreferencesActionTypes {
  Save = '[Allotment Preferences] Save'
}

export class SaveAllotmentPreferences implements Action {
  public readonly type = AllotmentPreferencesActionTypes.Save;

  constructor(public payload: AllotmentPreferences) { }
}

export type AllotmentPreferencesActionsUnion =
  | SaveAllotmentPreferences;